export default {
	"component.tagSelect.expand": "Expand",
	"component.tagSelect.collapse": "Collapse",
	"component.tagSelect.all": "All",
};
